<div class="event-line" [class.event-line--rejected]="rejected()">
	<span class="event-dates-block">
		<a class="event-dates" routerLink="/settlements/settlementBonus/{{ bonusId() }}" target="_blank">
			{{ date() | date: 'yyyy-MM-dd' }}
			@if (dayRange(); as to) {
				<span class="event-dash">–</span>
				{{ to | date: 'yyyy-MM-dd' }}
			}
			<span class="event-dash">·</span>
			{{ name() }}
		</a>
		@if (termsLabel() || foreignBonusDate()) {
			<small class="event-sublabel">
				@if (termsLabel(); as label) {
					{{ label }}
				}
				@if (termsLabel() && foreignBonusDate()) {
					<span class="event-dash">·</span>
				}
				@if (foreignBonusDate(); as bonusDate) {
					dodatek z {{ bonusDate | date: 'yyyy-MM-dd' }}
				}
			</small>
		}
	</span>
	<span class="event-amount" [class.event-amount--rejected]="rejected()">
		<strong [class.event-amount--pending]="!counted() && !rejected()">{{
			displayGrosze() | priceCurrency: 'PLN'
		}}</strong>
		@if (isForeign()) {
			<small class="event-amount-original" [matTooltip]="rateTooltip()" matTooltipPosition="above">
				<i class="fa-solid fa-arrow-right-arrow-left"></i>
				{{ amountGrosze() | priceCurrency: currency() }}
				@if (showRate()) {
					<span class="event-dash">·</span> kurs {{ exchangeRate() | number: '1.4-4' }} z
					{{ exchangeRateDate() | date: 'yyyy-MM-dd' }}
				}
			</small>
		}
		@if (plnConversionMissing()) {
			<span
				class="settlement-badge settlement-badge-warning"
				matTooltip="Brak kursu NBP na dzień rozliczenia — kwota nie została przeliczona na złotówki."
				matTooltipPosition="above"
			>
				<i class="fa-solid fa-triangle-exclamation"></i> Brak przeliczenia
			</span>
		}
		@if (confirmAt() && !rejected()) {
			<span class="settlement-badge settlement-badge-confirmed">Potwierdzone</span>
		}
		@if (!counted() && !rejected()) {
			<span
				class="settlement-badge settlement-badge-pending"
				matTooltip="Pozycja czeka na zatwierdzenie — nie jest wliczana do podsumowania."
				matTooltipPosition="above"
				>Niewliczone</span
			>
		}
		@if (rejected()) {
			<span
				class="settlement-badge settlement-badge-rejected"
				[matTooltip]="rejectReason() || ''"
				matTooltipPosition="above"
				>Odrzucone</span
			>
		}
	</span>
	<span class="event-actions">
		@if (actions().confirmable) {
			<button
				mat-stroked-button
				class="event-action-btn"
				[disabled]="disabled()"
				[matTooltip]="actions().confirm_disabled_reason || ''"
				(click)="confirm()"
			>
				<mat-icon><i class="fa-solid fa-check"></i></mat-icon>
				Zatwierdź
			</button>
		}
		@if (actions().unlockable) {
			<button
				mat-stroked-button
				class="event-action-btn"
				[disabled]="disabled()"
				[matTooltip]="actions().unlock_disabled_reason || ''"
				(click)="unlock()"
			>
				<mat-icon><i class="fa-solid fa-rotate-left"></i></mat-icon>
				Cofnij
			</button>
		}
		@if (actions().rejectable) {
			<button
				mat-stroked-button
				class="event-action-btn event-action-btn--danger"
				[disabled]="disabled()"
				[matTooltip]="actions().reject_disabled_reason || ''"
				(click)="reject()"
			>
				<mat-icon><i class="fa-solid fa-ban"></i></mat-icon>
				Odrzuć
			</button>
		}
		@if (actions().restorable) {
			<button mat-stroked-button class="event-action-btn" [disabled]="disabled()" (click)="restore()">
				<mat-icon><i class="fa-solid fa-rotate-left"></i></mat-icon>
				Cofnij
			</button>
		}
	</span>
</div>
@if (bonusComment()) {
	<span class="settlement-comment">{{ bonusComment() }}</span>
}
